'use client';
import {useTranslation} from 'react-i18next';
import {RettsstiftelseSearchForm} from 'features/search/components/rettsstiftelse-search-form';
import {SearchCard} from 'features/search/components/search-card';
import {getEnv} from 'environment/public.environment';
import {useEffect, useReducer, useState} from 'react';
import {useSession} from 'next-auth/react';
import {useWindowEventListener} from 'common/hooks/use-event-listener';
import {CssBreakpoints} from 'styles/responsive';
import ektepaktIllustration from 'features/search/illustrations/ektepakt.svg';
import {fnrValidator} from 'features/search/validators/fnr-validator';
import {useLang} from 'features/i18n/use-lang';
import {useRouter} from 'next/navigation';
import {generateTempPersonKey} from '../fetch-temp-person-key';

export const EktepaktSearchCard = () => {
  const {t} = useTranslation(['search']);
  const lang = useLang();
  const {status: sessionStatus, data: session} = useSession();
  const router = useRouter();

  const [isAuthenticated, setIsAuthenticated] = useState(sessionStatus === 'authenticated');
  useEffect(() => {
    if (sessionStatus !== 'loading') {
      setIsAuthenticated(sessionStatus === 'authenticated');
    }
  }, [sessionStatus]);

  const titleFromStatus = t('search:ektepakt.heading', isAuthenticated ? {} : {context: 'notAuth'});

  const [title, updateTitle] = useReducer(() => {
    if (window.innerWidth <= CssBreakpoints.XS) {
      return t('search:ektepakt.heading');
    }

    return titleFromStatus;
  }, titleFromStatus);

  useEffect(updateTitle, [sessionStatus]);
  useWindowEventListener('resize', updateTitle, []);

  const onSearch = async (fnr: string) => {
    try {
      const res = await generateTempPersonKey(fnr, session?.accessToken);
      if (res.status === 200) {
        const {key} = await res.json();
        return router.push(`/${lang}/oppslag/ektepakt/${key}`);
      } else {
        return router.push(`/${lang}/oppslag#ektepakt?register=ektepakt&type=person&error=status_${res.status}`);
      }
    } catch {
      return router.push(`/${lang}/oppslag#ektepakt?register=ektepakt&type=person&error=status_500`);
    }
  };

  return (
    <SearchCard
      id='ektepakt'
      requiresAuth
      imageSrc={ektepaktIllustration}
      title={title}
      subheader={t('search:ektepakt.subheading')}
    >
      <RettsstiftelseSearchForm
        searchType='person'
        register='ektepakt'
        validator={fnrValidator}
        inputName='fodselsnummer'
        disableAutocomplete
        mask='****** *****'
        onSearch={onSearch}
      />
      <p>
        <a href={getEnv().links.brreg.omEktepakt}>{t('search:ektepakt.readMore')}</a>
      </p>
    </SearchCard>
  );
};
